function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { renderless as renderless$1, api as api$1 } from "@opentiny/vue-renderless/tabs/vue";
import { $prefix, $props, setup as _setup, h, defineComponent, props } from "@opentiny/vue-common";
import { renderless, api } from "@opentiny/vue-renderless/tab-nav/vue";
import { iconClose, iconChevronDown, iconPlus } from "@opentiny/vue-icon";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

import { touchStart, touchMove } from "@opentiny/vue-renderless/common/deps/touch";
import "@opentiny/vue-theme-mobile/tabs/index.css";
var __vue2_script$1 = {
  name: $prefix + "TabNav",
  components: {
    IconClose: iconClose(),
    IconChevronDown: iconChevronDown()
  },
  props: _extends({}, $props, {
    panes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currentName: String,
    activeColor: {
      type: String,
      default: ""
    },
    onTabClick: {
      type: Function,
      default: function _default2() {
      }
    },
    onTabRemove: {
      type: Function,
      default: function _default3() {
      }
    },
    showExpandTabs: Boolean,
    expandPanesWidth: {
      type: String,
      default: ""
    },
    expandTabsTitle: {
      type: String,
      default: "请选择"
    },
    expandTabsMode: {
      type: String,
      default: "columns"
    }
  }),
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api,
      mono: true,
      h
    });
  },
  render: function render() {
    var h2 = arguments[0];
    var state = this.state, panes = this.panes, onTabClick = this.onTabClick, onTabRemove = this.onTabRemove, showExpandTabs = this.showExpandTabs, expandTabShow = this.expandTabShow, activeColor = this.activeColor, expandPanesWidth = this.expandPanesWidth, currentName = this.currentName, expandTabsTitle = this.expandTabsTitle, expandTabsMode = this.expandTabsMode;
    var tabsExpandIcon = showExpandTabs ? h2("div", {
      "class": "tiny-mobile-tabs__expand-icon"
    }, [h2("span", {
      "slot": "reference",
      "class": "tiny-mobile-tabs__expand",
      "on": {
        "click": function click() {
          expandTabShow();
        }
      }
    }, [h2("icon-chevron-down")])]) : null;
    var tabsExpandContent = h2("div", {
      "class": "tiny-mobile-tabs__expand-content",
      "style": state.showExpandItem ? {
        display: "block",
        width: expandPanesWidth ? expandPanesWidth + "px" : ""
      } : {
        display: "none"
      }
    }, [h2("div", {
      "class": "tiny-mobile-tabs__expand-mask"
    }), h2("div", {
      "class": "tiny-mobile-tabs__expand-header"
    }, [h2("label", {
      "class": "tiny-mobile-tabs__expand-header-title",
      "style": state.expandHeaderStyle
    }, [expandTabsTitle]), h2("span", {
      "slot": "reference",
      "class": "tiny-mobile-tabs__expand",
      "style": {
        transform: "rotate(180deg)"
      }
    }, [h2("icon-chevron-down")])]), h2("div", {
      "class": "tiny-mobile-tabs__expand-list"
    }, [panes.map(function(pane, index) {
      var _class;
      var tabName = pane.name || pane.state.index || index;
      var tabTitle = pane.$slots.title || pane.title;
      return h2("div", {
        "class": (_class = {
          "tiny-mobile-tabs__expand-item": true
        }, _class["tiny-mobile-tabs__expand-mode-" + expandTabsMode] = expandTabsMode === "columns", _class)
      }, [h2("div", {
        "class": {
          "tiny-mobile-tabs__expand-item-title": true,
          "is-current": currentName === tabName
        },
        "on": {
          "click": function click(e) {
            onTabClick(pane, tabName, e);
          }
        }
      }, [tabTitle])]);
    })])]);
    var tabs = panes.map(function(pane, index) {
      var _class2;
      var tabName = pane.name || pane.state.index || index;
      var withClose = pane.state.isClosable;
      pane.state.index = "" + index;
      var btnClose = withClose && panes.length > 1 ? h2("span", {
        "class": "tiny-mobile-tabs__icon-close"
      }, [h2("icon-close", {
        "on": {
          "click": function click(e) {
            onTabRemove(pane, e);
          }
        }
      })]) : null;
      var tabTitle = pane.$slots.title || pane.title;
      return h2("div", {
        "class": (_class2 = {
          "tiny-mobile-tabs__item": true
        }, _class2["is-" + state.rootTabs.position] = true, _class2["is-active"] = pane.state.active, _class2["is-disabled"] = pane.disabled, _class2["is-closable"] = withClose, _class2),
        "attrs": {
          "role": "tab",
          "id": "tab-" + tabName,
          "aria-controls": "pane-" + tabName,
          "aria-selected": pane.state.active
        },
        "ref": "tabs",
        "key": "tab-" + tabName,
        "on": {
          "click": function click(e) {
            onTabClick(pane, tabName, e);
          }
        }
      }, [h2("span", {
        "class": "tiny-mobile-tabs__name",
        "style": activeColor && pane.state.active ? {
          color: activeColor
        } : {}
      }, [tabTitle, btnClose])]);
    });
    return h2("div", {
      "style": showExpandTabs ? {
        paddingRight: "46px"
      } : {},
      "class": ["tiny-mobile-tabs__nav-wrap", state.scrollable ? "is-scrollable" : "", panes.length > 4 ? "tiny-mobile-tabs__wrap-scrollable" : "", showExpandTabs ? "is-show-expand" : "", "is-" + state.rootTabs.position]
    }, [h2("div", {
      "class": ["tiny-mobile-tabs__nav-scroll"],
      "ref": "navScroll"
    }, [h2("div", {
      "class": ["tiny-mobile-tabs__nav", "is-" + state.rootTabs.position],
      "ref": "nav",
      "attrs": {
        "role": "tablist"
      }
    }, [tabs, h2("div", {
      "class": "tiny-mobile-tabs__line",
      "style": [state.navStyle, activeColor ? {
        backgroundColor: activeColor
      } : {}]
    })])]), [tabsExpandIcon, tabsExpandContent]]);
  }
};
var __vue2_render$1, __vue2_staticRenderFns$1;
var __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(__vue2_script$1, __vue2_render$1, __vue2_staticRenderFns$1, false, __vue2_injectStyles$1, null, null, null);
function __vue2_injectStyles$1(context) {
  for (var o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
var TabNav = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var MIN_SWIPE_DISTANCE = 50;
var __vue2_script = defineComponent({
  props: [].concat(props, ["activeName", "position", "withClose", "withAdd", "activeColor", "modelValue", "beforeLeave", "editable", "showExpandTabs", "childrenTabs", "swipeable", "expandTabsTitle", "expandTabsMode"]),
  components: {
    TabNav,
    IconPlus: iconPlus()
  },
  setup: function setup2(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless: renderless$1,
      api: api$1
    });
  },
  methods: {
    getCurIndex: function getCurIndex() {
      var _this = this;
      var current = 0;
      this.state.panes.filter(function(node, index) {
        return node.name === _this.state.currentName && (current = index);
      });
      return current;
    },
    onTouchEnd: function onTouchEnd() {
      var _this$state = this.state, direction = _this$state.direction, deltaX = _this$state.deltaX;
      var currentIndex = this.getCurIndex();
      if (direction === "horizontal" && this.state.offsetX >= MIN_SWIPE_DISTANCE) {
        if (deltaX > 0 && currentIndex !== 0) {
          var name = this.state.panes[currentIndex - 1].name;
          this.$emit("swipeLeft", name);
          this.setCurrentName(name);
          this.$refs.nav.scrollToActiveTab();
        } else if (deltaX < 0 && currentIndex !== this.state.panes.length - 1) {
          var _name = this.state.panes[currentIndex + 1].name;
          this.$emit("swipeRight", _name);
          this.setCurrentName(_name);
          this.$refs.nav.scrollToActiveTab();
        }
      }
    }
  },
  render: function render2() {
    var _class3;
    var h2 = arguments[0];
    var state = this.state, position = this.position, handleTabClick = this.handleTabClick, handleTabRemove = this.handleTabRemove, handleTabAdd = this.handleTabAdd, editable = this.editable, withAdd = this.withAdd, showExpandTabs = this.showExpandTabs, swipeable = this.swipeable, activeColor = this.activeColor, expandTabsTitle = this.expandTabsTitle, expandTabsMode = this.expandTabsMode;
    var newButton = editable || withAdd ? h2("span", {
      "class": "tiny-mobile-tabs__new-tab",
      "on": {
        "click": handleTabAdd,
        "keydown": function keydown(ev) {
          if (ev.keyCode === 13) {
            handleTabAdd();
          }
        }
      },
      "attrs": {
        "tabindex": "0"
      }
    }, [h2("icon-plus")]) : null;
    var navData = {
      props: {
        currentName: state.currentName,
        panes: state.panes,
        activeColor,
        onTabClick: handleTabClick,
        onTabRemove: handleTabRemove,
        showExpandTabs,
        expandPanesWidth: state.expandPanesWidth,
        expandTabsTitle,
        expandTabsMode
      },
      ref: "nav"
    };
    var TabNavComponent = h2(TabNav, _extends({}, navData));
    var header = h2("div", {
      "class": ["tiny-mobile-tabs__header", "is-" + position]
    }, [newButton, TabNavComponent]);
    var listeners = swipeable ? {
      touchstart: touchStart(state),
      touchmove: touchMove(state),
      touchend: this.onTouchEnd,
      touchcancel: this.onTouchEnd
    } : {};
    var panels = h2("div", {
      class: "tiny-mobile-tabs__content",
      on: _extends({}, listeners)
    }, this.slots.default());
    return h2("div", {
      "class": (_class3 = {
        "tiny-mobile-tabs": true
      }, _class3["tiny-mobile--" + position] = true, _class3)
    }, [[header, panels]]);
  }
});
var __vue2_render, __vue2_staticRenderFns;
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, __vue2_render, __vue2_staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobile = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobile as default
};
